import React from "react";
import Sidebar from "../admin/sidebar/Sidebar";
import Careers from "../admin/career/Career";

function AdminCareersPage() {
  return (
    <div>
      <Sidebar />
      <Careers />
    </div> 
  );
}

export default AdminCareersPage;
